import { useSelector } from 'react-redux';
import {
    subscriptionExpiredInformerEnabled,
    subscriptionInformerEnabled,
    subscriptionInformerInterval,
    subsExpiredInformerCountStorageKey,
    subsExpiredInformerStorageKey,
    subsInformerStorageKey,
} from 'reactApp/appHelpers/featuresHelpers/features/subscriptionsInformer';
import { getExpiredSubscriptionForRenew, getLastSubscriptionForRenew } from 'reactApp/modules/billingData/billingData.ssr.selectors';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { isCloudOrMailOrApiOverQuota } from 'reactApp/modules/userQuota/overquota.helpers';

export const useSubscriptionInformerInfo = () => {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const subscriptionForRenew = useSelector(getLastSubscriptionForRenew);
    const expiredSubscriptionForRenew = useSelector(getExpiredSubscriptionForRenew);
    const isOverQuota = useSelector(isCloudOrMailOrApiOverQuota);

    if (isOverQuota) {
        return null;
    }

    if (isPaidUser) {
        // если не включена фича для баннера продления
        if (isPaidUser && (!subscriptionInformerEnabled || subscriptionInformerEnabled === 'a')) {
            return null;
        }

        // если не прошло subscriptionInformerInterval дней с последнего показа
        if (
            storeHelper.getValue(subsInformerStorageKey) &&
            !storeHelper.isPassed(subsInformerStorageKey, { daysCount: subscriptionInformerInterval })
        ) {
            return null;
        }

        // если есть подписка, у которой до окончания осталось 30 дней
        if (subscriptionForRenew) {
            return {
                subscription: subscriptionForRenew,
            };
        }
    }

    // если у юзера есть подписки, то не показываем ему информер про истекшую подписку
    if (isPaidUser) {
        return null;
    }

    // если не включена фича для баннера возобновления
    if (!subscriptionExpiredInformerEnabled || subscriptionExpiredInformerEnabled === 'a') {
        return null;
    }

    // если не прошло 7 дней с последнего закрытия
    if (storeHelper.getValue(subsExpiredInformerStorageKey) && !storeHelper.isPassed(subsExpiredInformerStorageKey, { daysCount: 7 })) {
        return null;
    }

    // если баннер закрывали больше 2ух раз
    if (storeHelper.getValue(subsExpiredInformerCountStorageKey) > 2) {
        return null;
    }

    if (expiredSubscriptionForRenew) {
        return {
            productId: expiredSubscriptionForRenew.productId,
        };
    }
};
